import PromoUsageWarningDialog from 'features/ManageCampaigns/EditPromoDialog/PromoUsageWarningDialog'
import usePromoValidation from 'hooks/usePromoValidaiton'
import { useState } from 'react'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog'
import { EditPromo } from './EditPromo'

export const EditPromoDialog = ({
  title,
  minNightsToStay = 1,
  maxDiscountPercentage = 15,
  promotionCode,
  handleCloseDialog,
  handleSave,
  promotionTagline = 'The best rate',
  ...props
}) => {
  const [promoCode, setPromoCode] = useState(promotionCode)
  const [minNights, setMinNights] = useState(minNightsToStay)
  const [maxDiscount, setMaxDiscount] = useState(maxDiscountPercentage)
  const [promoTagline, setPromoTagline] = useState(promotionTagline)

  const [hasPromoValidityDate, setHasPromoValidityDate] = useState(
    props.hasPromoValidityDate
  )
  const [promoValidityStartDate, setPromoValidityStartDate] = useState(
    props.promoValidityStartDate ? new Date(props.promoValidityStartDate) : null
  )
  const [promoValidityEndDate, setPromoValidityEndDate] = useState(
    props.promoValidityEndDate ? new Date(props.promoValidityEndDate) : null
  )
  const [showPromoUsageWarning, setShowPromoUsageWarning] = useState(null)
  const [isUsingDiscount, setIsUsingDiscount] = useState(!!promotionCode)

  const isPromoValid = isUsingDiscount
    ? !!promoCode?.match(/^[A-Za-z0-9]{1,15}$/gm)
    : true

  function saveChanges() {
    handleSave({
      promoCode,
      minNights,
      maxDiscount,
      promoTagline,
      hasPromoValidityDate,
      promoValidityStartDate,
      promoValidityEndDate
    })
  }

  const { checkRateCodeUsage } = usePromoValidation(promoCode)

  async function handleConfirmDialog() {
    const { messageType } = await checkRateCodeUsage(promoCode)

    if (!messageType) {
      saveChanges()
    }

    setShowPromoUsageWarning(messageType)
  }

  if (showPromoUsageWarning) {
    return (
      <PromoUsageWarningDialog
        softMessage={true}
        promoCode={promoCode}
        onClose={() => setShowPromoUsageWarning(false)}
        onConfirm={saveChanges}
        showPromoUsageWarning={showPromoUsageWarning}
      />
    )
  }

  return (
    <ConfirmationDialog
      title={title}
      positiveMessage="Save changes"
      negativeMessage="Cancel"
      onConfirm={handleConfirmDialog}
      onClose={() => handleCloseDialog()}
      isButtonDisabled={promoTagline.length === 0 || (isUsingDiscount && !isPromoValid)}
      contentPadding={0}
    >
      <EditPromo
        promoCode={promoCode}
        setPromoCode={setPromoCode}
        minNights={minNights}
        setMinNights={setMinNights}
        maxDiscount={maxDiscount}
        setMaxDiscount={setMaxDiscount}
        promoTagline={promoTagline}
        setPromoTagline={setPromoTagline}
        hasPromoValidityDate={hasPromoValidityDate}
        setHasPromoValidityDate={setHasPromoValidityDate}
        promoValidityStartDate={promoValidityStartDate}
        setPromoValidityStartDate={setPromoValidityStartDate}
        promoValidityEndDate={promoValidityEndDate}
        setPromoValidityEndDate={setPromoValidityEndDate}
        isUsingDiscount={isUsingDiscount}
        setIsUsingDiscount={setIsUsingDiscount}
        isPromoValid={isPromoValid}
      />
    </ConfirmationDialog>
  )
}

export default EditPromoDialog
